import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

const EXCEL_EXTENSION = '.xlsx';

@Injectable({
    providedIn: 'root'
})
export class ExcelService {

    constructor() { }

    public exportAsExcelFile(json: any[], excelFileName: string, excelSheetName): void {
        let workbook: XLSX.WorkBook;
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);


        if (excelSheetName === 'Clientes') {
            workbook = { Sheets: { 'Clientes': worksheet }, SheetNames: ['Clientes'] };
        }

        if (excelSheetName === 'Empleados') {
            workbook = { Sheets: { 'Empleados': worksheet }, SheetNames: ['Empleados'] };
        }

        if (excelSheetName === 'PersonasRelacionadas') {
            workbook = { Sheets: { 'PersonasRelacionadas': worksheet }, SheetNames: ['PersonasRelacionadas'] };
        }

        if (excelSheetName === 'Coincidencias') {
            workbook = { Sheets: { 'Coincidencias': worksheet }, SheetNames: ['Coincidencias'] };
        }

        if (excelSheetName === 'Alertas') {
            workbook = { Sheets: { 'Alertas': worksheet }, SheetNames: ['Alertas'] };
        }


        if (excelSheetName === 'AlertasComite') {
            workbook = { Sheets: { 'AlertasComite': worksheet }, SheetNames: ['AlertasComite'] };
        }


        if (excelSheetName === 'Transacciones') {
            workbook = { Sheets: { 'Transacciones': worksheet }, SheetNames: ['Transacciones'] };
        }

        if (excelSheetName === 'Relevantes') {
            workbook = { Sheets: { 'Relevantes': worksheet }, SheetNames: ['Relevantes'] };
        }

        if (excelSheetName === 'Inusuales') {
            workbook = { Sheets: { 'Inusuales': worksheet }, SheetNames: ['Inusuales'] };
        }

        if (excelSheetName === 'InternasPreocupantes') {
            workbook = {
                Sheets: { 'Internas Preocupantes': worksheet }, SheetNames: ['Internas Preocupantes']
            };
        }

        if (excelSheetName === 'ClientesCalificados') {
            workbook = {
                Sheets:
                    { 'Clientes Calificados': worksheet }, SheetNames: ['Clientes Calificados']
            };
        }

        if (excelSheetName === 'EBR') {
            workbook = { Sheets: { 'EBR': worksheet }, SheetNames: ['EBR'] };
        }

        if (excelSheetName === 'BitacoraUsuario') {
            workbook = {
                Sheets:
                    { 'Bitácora de Usuarios': worksheet }, SheetNames: ['Bitácora de Usuarios']
            };
        }

        if (excelSheetName === 'BitacoraAcceso') {
            workbook = {
                Sheets: { 'Bitácora de Accesos': worksheet }, SheetNames: ['Bitácora de Accesos']
            };
        }

        if (excelSheetName === 'Física') {
            workbook = { Sheets: { 'Física': worksheet }, SheetNames: ['Física'] };
        }

        if (excelSheetName === 'Moral') {
            workbook = { Sheets: { 'Moral': worksheet }, SheetNames: ['Moral'] };
        }



        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
        FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
    }


}
